import { Injectable } from '@angular/core';
import { AvailableOperationTypes } from '../../../finish-pro/models/operations/available-operation-types';
import { TranslateService } from '../../../core/translation';
import { IntroTexts } from '../../../finish-pro/pages/document-viewer/types/document-viewer-types';

@Injectable({
  providedIn: 'root'
})
export class TranslateDataService {

  texts: IntroTexts = {
    title: '',
    titleStep1: '',
    titleStep2: '',
    titleStep3: '',
    titleStep4: '',
    descriptionStep1: '',
    descriptionStep2: '',
    descriptionStep3: '',
    descriptionStep4: '',
  };

  constructor(private _translate: TranslateService) { }


  public getTranslationsIntro(operationType: string, totalDocs: number, nameUser: string, userCreator: string, operationName: string): IntroTexts {
    switch (operationType) {
      case AvailableOperationTypes.SIGBIO:
      case AvailableOperationTypes.SIG:
      case AvailableOperationTypes.ACEP:
        this.texts.title = this._translate.instant('signaturit_pro.intro.title', {valueParam: operationName});
        this.texts.intro = totalDocs === 1 ? this._translate.instant('signaturit_pro.intro.introductory_text', { valueParam: nameUser, valueParam2: userCreator, valueParam3: totalDocs?.toString() }) :
          this._translate.instant('signaturit_pro.intro.introductory_text_multiple', { valueParam: nameUser, valueParam2: userCreator, valueParam3: totalDocs?.toString() });
        this.texts.titleStep1 = this._translate.instant('signaturit_pro.intro.step1_title');
        this.texts.titleStep2 = totalDocs === 1 ? this._translate.instant('signaturit_pro.intro.step2_title') : this._translate.instant('signaturit_pro.intro.step2_title_multiple');
        this.texts.titleStep3 = this._translate.instant('signaturit_pro.intro.step3_title');
        this.texts.titleStep4 = '';
        this.texts.descriptionStep1 = this._translate.instant('signaturit_pro.intro.description1');
        this.texts.descriptionStep2 = totalDocs === 1 ? this._translate.instant('signaturit_pro.intro.description2') : this._translate.instant('signaturit_pro.intro.description2_multiple');
        this.texts.descriptionStep3 = this._translate.instant('signaturit_pro.intro.description3');
        this.texts.descriptionStep4 = '';
        break;
      case AvailableOperationTypes.RVDOTP:
        this.texts.title = this._translate.instant('signaturit_pro.intro.title', {valueParam: operationName});
        this.texts.intro = totalDocs === 1 ? this._translate.instant('signaturit_pro.intro.introductory_text', { valueParam: nameUser, valueParam2: userCreator, valueParam3: totalDocs?.toString() }) :
          this._translate.instant('signaturit_pro.intro.introductory_text_multiple', { valueParam: nameUser, valueParam2: userCreator, valueParam3: totalDocs?.toString() });
        this.texts.titleStep1 = this._translate.instant('signaturit_pro.intro.step1_title');
        this.texts.titleStep2 = totalDocs === 1 ? this._translate.instant('signaturit_pro.intro.step2_title') : this._translate.instant('signaturit_pro.intro.step2_title_multiple');
        this.texts.titleStep3 = this._translate.instant('signaturit_pro.intro.step3_title');
        this.texts.titleStep4 = '';
        this.texts.descriptionStep1 = this._translate.instant('signaturit_pro.intro.description1');
        this.texts.descriptionStep2 = totalDocs === 1 ? this._translate.instant('signaturit_pro.intro.description2') : this._translate.instant('signaturit_pro.intro.description2_multiple');
        this.texts.descriptionStep3 = this._translate.instant('signaturit_pro.intro.description3_rvdotp');
        this.texts.descriptionStep4 = '';
        break;
      case AvailableOperationTypes.DWN:
        this.texts.title = this._translate.instant('signaturit_pro.intro.title', {valueParam: operationName});
        this.texts.intro = totalDocs === 1 ? this._translate.instant('signaturit_pro.intro.introductory_text', { valueParam: nameUser, valueParam2: userCreator, valueParam3: totalDocs?.toString() }) :
          this._translate.instant('signaturit_pro.intro.introductory_text_multiple', { valueParam: nameUser, valueParam2: userCreator, valueParam3: totalDocs?.toString() });
        this.texts.titleStep1 = this._translate.instant('signaturit_pro.intro.step2_title_dwn');
        this.texts.titleStep2 = '';
        this.texts.titleStep3 = '';
        this.texts.titleStep4 = '';
        this.texts.descriptionStep1 = this._translate.instant('signaturit_pro.intro.description2_dwn');
        this.texts.descriptionStep2 = '';
        this.texts.descriptionStep3 = '';
        this.texts.descriptionStep4 = '';
        break;
      case AvailableOperationTypes.DYNSIG:
        this.texts.title = this._translate.instant('signaturit_pro.intro.title', {valueParam: operationName});
        this.texts.intro = totalDocs === 1 ? this._translate.instant('signaturit_pro.intro.introductory_text', { valueParam: nameUser, valueParam2: userCreator, valueParam3: totalDocs?.toString() }) :
          this._translate.instant('signaturit_pro.intro.introductory_text_multiple', { valueParam: nameUser, valueParam2: userCreator, valueParam3: totalDocs?.toString() });
        this.texts.titleStep1 = this._translate.instant('signaturit_pro.intro.step1_title_dynsig');
        this.texts.titleStep2 = this._translate.instant('signaturit_pro.intro.step1_title');
        this.texts.titleStep3 = totalDocs === 1 ? this._translate.instant('signaturit_pro.intro.step2_title') : this._translate.instant('signaturit_pro.intro.step2_title_multiple');
        this.texts.titleStep4 = this._translate.instant('signaturit_pro.intro.step3_title');
        this.texts.descriptionStep1 = this._translate.instant('signaturit_pro.intro.description1_dynsig');
        this.texts.descriptionStep2 = this._translate.instant('signaturit_pro.intro.description1');
        this.texts.descriptionStep3 = totalDocs === 1 ? this._translate.instant('signaturit_pro.intro.description2') : this._translate.instant('signaturit_pro.intro.description2_multiple');
        this.texts.descriptionStep4 = this._translate.instant('signaturit_pro.intro.description3');
        break;
      case AvailableOperationTypes.NOTE:
        this.texts.title = this._translate.instant('signaturit_pro.intro.title_note');
        this.texts.intro = this._translate.instant('signaturit_pro.intro.introductory_text_note', { valueParam: nameUser, valueParam2: userCreator });
        this.texts.titleStep1 = this._translate.instant('signaturit_pro.intro.step1_title_note');
        this.texts.titleStep2 = this._translate.instant('signaturit_pro.intro.step2_title_note');
        this.texts.titleStep3 = '';
        this.texts.titleStep4 = '';
        this.texts.descriptionStep1 = this._translate.instant('signaturit_pro.intro.description1_note');
        this.texts.descriptionStep2 = this._translate.instant('signaturit_pro.intro.description2_note');
        this.texts.descriptionStep3 = '';
        this.texts.descriptionStep4 = '';
        break;
      case AvailableOperationTypes.VAL:
        this.texts.title = this._translate.instant('signaturit_pro.intro.title', {valueParam: operationName});
        this.texts.intro = totalDocs === 1 ? this._translate.instant('signaturit_pro.intro.introductory_text', { valueParam: nameUser, valueParam2: userCreator, valueParam3: totalDocs?.toString() }) :
          this._translate.instant('signaturit_pro.intro.introductory_text_multiple', { valueParam: nameUser, valueParam2: userCreator, valueParam3: totalDocs?.toString() });
        this.texts.titleStep1 = this._translate.instant('signaturit_pro.intro.step1_title');
        this.texts.titleStep2 = totalDocs === 1 ? this._translate.instant('signaturit_pro.intro.step2_title') : this._translate.instant('signaturit_pro.intro.step2_title_multiple');
        this.texts.titleStep3 = this._translate.instant('signaturit_pro.intro.step3_title_val');
        this.texts.titleStep4 = '';
        this.texts.descriptionStep1 = this._translate.instant('signaturit_pro.intro.description1');
        this.texts.descriptionStep2 = this._translate.instant('signaturit_pro.intro.description2_val');
        this.texts.descriptionStep3 = this._translate.instant('signaturit_pro.intro.description3_val');
        this.texts.descriptionStep4 = '';
        break;
      default:
        this.texts.title = this._translate.instant('signaturit_pro.intro.title', {valueParam: operationName});
        this.texts.intro = totalDocs === 1 ? this._translate.instant('signaturit_pro.intro.introductory_text', { valueParam: nameUser, valueParam2: userCreator, valueParam3: totalDocs?.toString() }) :
          this._translate.instant('signaturit_pro.intro.introductory_text_multiple', { valueParam: nameUser, valueParam2: userCreator, valueParam3: totalDocs?.toString() });
        this.texts.titleStep1 = this._translate.instant('signaturit_pro.intro.step1_title');
        this.texts.titleStep2 = totalDocs === 1 ? this._translate.instant('signaturit_pro.intro.step2_title') : this._translate.instant('signaturit_pro.intro.step2_title_multiple');
        this.texts.titleStep3 = this._translate.instant('signaturit_pro.intro.step3_title');
        this.texts.titleStep4 = '';
        this.texts.descriptionStep1 = this._translate.instant('signaturit_pro.intro.description1');
        this.texts.descriptionStep2 = totalDocs === 1 ? this._translate.instant('signaturit_pro.intro.description2') : this._translate.instant('signaturit_pro.intro.description2_multiple');
        this.texts.descriptionStep3 = this._translate.instant('signaturit_pro.intro.description3');
        this.texts.descriptionStep4 = '';
        break;
    }

    return this.texts;
  }

}
